/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ImplicitOAuthFlow } from '../../../core/models/common/ImplicitOAuthFlow';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Models an OpenAPI 3.0.x implicit OAuth flow.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ImplicitOAuthFlow
 */
export class Oas30ImplicitOAuthFlow extends ImplicitOAuthFlow {
    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitImplicitOAuthFlow(this);
    }

    constructor() {
        super();
    }
}
Oas30ImplicitOAuthFlow["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30ImplicitOAuthFlow";
Oas30ImplicitOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




